import { tv } from "../../variants/tv.js";
const BASE_TRANSITION = 'transition duration-300';
const actionCardVariants = tv({
    slots: {
        baseSlot: [
            'group',
            'flex',
            'items-center',
            'text-left',
            'min-h-20',
            'overflow-clip',
            'rounded-xl',
            'cursor-pointer',
            BASE_TRANSITION,
            'active:bg-primary-4',
            'focus-visible:outline-none',
            'focus-visible:ring-2',
            'focus-visible:ring-actionSecondary-12',
            'focus-visible:ring-offset-2'
        ],
        mediaSlot: [
            'shrink-0',
            'flex',
            'items-center',
            'self-stretch'
        ],
        contentSlot: [
            'flex',
            'flex-1',
            'flex-col',
            'gap-1',
            'p-3',
            'min-w-0'
        ],
        eyebrowSlot: 'w-full',
        headingSlot: 'w-full',
        bodySlot: 'w-full',
        iconSlot: [
            'shrink-0',
            'flex',
            'items-center',
            'pr-3'
        ],
        iconInnerSlot: [
            BASE_TRANSITION,
            'transition-[translate]'
        ]
    },
    variants: {
        elevated: {
            true: {
                baseSlot: [
                    'bg-primary-1',
                    'border-none',
                    'shadow-md',
                    'transition-[background-color,box-shadow]',
                    'hover:shadow-xl'
                ]
            },
            false: {
                baseSlot: [
                    'bg-primary-1',
                    'border',
                    'border-neutral-4',
                    'hover:bg-primary-3'
                ]
            }
        },
        mediaType: {
            icon: {
                mediaSlot: 'py-2 pl-3.5'
            },
            image: {
                mediaSlot: 'max-w-16'
            }
        },
        actionType: {
            link: {
                iconInnerSlot: 'group-hover:translate-x-1'
            },
            info: {}
        },
        readOnly: {
            true: {
                baseSlot: [
                    'cursor-default',
                    'pointer-events-none',
                    'shadow-none',
                    'border-0'
                ],
                mediaSlot: [
                    'rounded-xl',
                    'overflow-clip'
                ]
            },
            false: {}
        }
    },
    compoundVariants: [],
    defaultVariants: {
        elevated: true,
        mediaType: 'icon',
        actionType: 'link',
        mediaPalette: 'primary'
    }
});
export { actionCardVariants };
